var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen transparent",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"v-page-fade"}},[_c('prompt-cancellation')],1),_c('transition',{attrs:{"name":"v-page-fade"}},[_c('router-view',{staticClass:"h-screen"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }